// components/Header/index.js

'use client'
import { Flex } from 'antd';
import Logo from './logo';
import SearchBar from './searchBar';
import HeaderBar from './headerBar';
import './header.scss';

export default function Header() {

    return (
        <header className="page_header">
            <div className='page_header_bx'>
                <Flex align='center' justify='space-between'>
                    <Logo />
                    <SearchBar />
                    <HeaderBar />
                </Flex>
            </div>
        </header>
    );
}